import { PARTICIPANT_STATUS } from '../constants';

// Stati, mit denen ein Teilnehmer NICHT mehr aktiv an der Session teilnimmt.
// Das Backend liefert in `participants` auch LEFT-Records mit (Audit-Trail) -
// ohne diesen Filter "laeuft" eine verlassene Session im Frontend weiter.
export const INACTIVE_PARTICIPANT_STATUSES = [
  PARTICIPANT_STATUS.LEFT,
  PARTICIPANT_STATUS.KICKED,
  PARTICIPANT_STATUS.REJECTED,
];

export const isActiveParticipant = (participant) => {
  if (!participant) return false;
  // Uppercase-normalisieren: Altdaten/Tests nutzen teils lowercase-Stati
  const status = String(participant.status || '').toUpperCase();
  return !INACTIVE_PARTICIPANT_STATUSES.includes(status);
};

// Ungefilterter Lookup - fuer Completed-Ansichten (Aura/Feedback), wo der
// eigene Record nach Sessionende bewusst LEFT ist.
export const findParticipant = (participants, userId) => {
  if (!participants || userId == null) return undefined;
  const id = String(userId);
  return participants.find(p => String(p.id) === id || String(p.userId) === id);
};

export const findActiveParticipant = (participants, userId) => {
  const participant = findParticipant(participants, userId);
  return isActiveParticipant(participant) ? participant : undefined;
};

export const countActiveParticipants = (participants) =>
  (participants || []).filter(isActiveParticipant).length;

// Entfernt generierte Avatare (data:-URIs) aus den Teilnehmern einer Session-Liste.
// Sie wuerden den BrowserCacheService unnoetig belasten (~1-2KB pro Teilnehmer im
// localStorage-Budget). Echte Bildpfade bleiben seit Oktober 2026 erhalten: Die
// Session-Karte zeigt die Teilnehmenden als Avatar-Stapel (wie im Werbespot).
const isGeneratedImage = value => typeof value === 'string' && value.startsWith('data:');

export const stripParticipantImages = (sessions) =>
  (sessions || []).map((session) =>
    Array.isArray(session.participants)
      ? {
          ...session,
          participants: session.participants.map(({ image, avatar, ...participant }) => ({
            ...participant,
            ...(image && !isGeneratedImage(image) ? { image } : {}),
            ...(avatar && !isGeneratedImage(avatar) ? { avatar } : {}),
          }))
        }
      : session
  );
